/**
 * Mixpanel Configuration for Multi-Environment Setup
 * 
 * This file handles Mixpanel token configuration based on environment.
 * It supports:
 * - Production: Uses VITE_MIXPANEL_TOKEN
 * - Development: Uses VITE_MIXPANEL_TOKEN
 * Environment is automatically detected (prod vs dev)
 */

export interface MixpanelConfig {
  token: string;
  environment: string;
  debug: boolean;
}

/**
 * Get Mixpanel configuration based on current environment
 */
export function getMixpanelConfig(): MixpanelConfig {
  const isProduction = import.meta.env.PROD;
  const environment = isProduction ? 'production' : 'development';

  // Get the Mixpanel token (same variable for both environments)
  // You can set different values in .env.local for dev vs production deployments
  const token = import.meta.env.VITE_MIXPANEL_TOKEN;

  if (!token) {
    console.warn(`VITE_MIXPANEL_TOKEN environment variable is missing. Mixpanel will be disabled for ${environment}.`);
    // Return config with empty token - Mixpanel won't initialize but app won't break
    return {
      token: '',
      environment,
      debug: false,
    };
  }

  console.log(`Mixpanel configuration: ${environment} (token: ${token.substring(0, 8)}...)`);

  return {
    token,
    environment,
    debug: !isProduction, // Only enable debug mode in development
  };
}
